import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const nestingInstruction = css`
	.select {
		width: 100px;
	}

	.containerClasses {
		columns: 2;
		border: 1px solid ${colors.border};
		border-radius: 4px;
		padding: 10px;
	}
`;
